function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as i } from "react/jsx-runtime";
import * as d from "react";
import u from "classnames";
import { assignInlineVars as b } from "@vanilla-extract/dynamic";
import { sprinkles as y } from "./sprinkles.css-mistica.js";
import { getPrefixedDataAttributes as h } from "./utils/dom.js";
import { wrap as c, fullWidth as v, noFullWidth as x, justifyVariants as W, vars as g } from "./inline.css-mistica.js";
const I = (param)=>{
    let { space: r , className: e , children: l , role: o , alignItems: n = "stretch" , "aria-labelledby": a , fullWidth: s , wrap: m , dataAttributes: f  } = param;
    const p = s || typeof r == "string";
    return /* @__PURE__ */ i("div", _object_spread_props(_object_spread({
        className: u(e, y({
            alignItems: n
        }), m ? c : p ? v : x, typeof r != "number" && W[r]),
        style: typeof r == "number" ? b({
            [g.space]: `${r}px`
        }) : void 0,
        role: o,
        "aria-labelledby": a
    }, h(f)), {
        children: d.Children.map(l, (t)=>t || t === 0 ? /* @__PURE__ */ i("div", {
                children: t
            }) : null)
    }));
}, A = I;
export { A as default };
